import { render } from "./LocalizedLink.vue?vue&type=template&id=5fc35011"
import script from "./LocalizedLink.vue?vue&type=script&lang=js"
export * from "./LocalizedLink.vue?vue&type=script&lang=js"

import exportComponent from "/build/c65b55b7-e35c-4745-8ca4-2d2ba1e583e5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__